import { withCompInfo } from '@wix/editor-elements-integrations'
import { AppPartCss } from './AppPart'

export const css = withCompInfo<AppPartCss, never>()([], () => ({
	height: 'auto',
}))
